import { WebsiteMigration } from './website-migrations.models';

export interface WebsiteComposite {
  website: Website;
  details: WebsiteDetails;
  staging: WebsiteStaging;
  alias?: WebsiteAlias;
  group?: WebsiteGroup;
}

export interface WebsiteDetails {
  id: number;
  vhostId: number | null;
  sslCertificateId: number | null;
  unixUserId: number;
  databaseIds: number[];
}

export interface WebsiteAlias {
  parentId: number;
}

export interface WebsiteStaging {
  parentId: number;
}

export interface WebsiteGroup {
  id: number;
  mainWebsite: number;
  owner: string;
  plan: number;
  websites: Website[];
}

export interface Website {
  id: number;
  domain: string;
  originServer: string;
  userId: string;
  details: WebsiteDetails;
  staging: WebsiteStaging | null;
  status: string;
  type: string;
  createdAt: string;
}

export interface WebsiteCreationActionLog {
  id: number;
  log: string;
  createdDate: string;
}

export interface WebsiteCreationAction {
  id: number;
  action: string;
  parentActionsIds: number[];
  logs: WebsiteCreationActionLog[];
  status: string;
  createdDate: string;
  updatedDate: string;
}

export interface WebsiteCreation {
  id: number;
  websiteId: number;
  actions: WebsiteCreationAction[];
  status: string;
  createdDate: string;
  updatedDate: string;
}

export interface WebsiteDeletionActionLog {
  id: number;
  log: string;
  createdDate: string;
}

export interface WebsiteDeletion {
  id: number;
  websiteId: number;
  status: string;
  type: string;
  actions: WebsiteDeletionAction[];
  createdDate: string;
  updatedDate: string;
}

export interface WebsiteDeletionAction {
  id: number;
  action: string;
  parentActionsIds: number[];
  deletion: WebsiteDeletion;
  logs: WebsiteDeletionActionLog[];
  status: string;
  createdDate: string;
  updatedDate: string;
}

export enum WebsiteEnvironment {
  ALIAS = 'alias',
  SUB = 'sub',
}

export enum ToggleActionStatus {
  PENDING = 'pending',
  IN_PROGRESS = 'in progress',
  FAILED = 'failed',
  RETRY = 'retry',
  RETRYING = 'retrying',
  DONE = 'done',
}

export interface ToggleLog {
  id: number;
  log: string;
}

export enum WebsiteCreationStatus {
  PENDING = 'pending',
  DONE = 'done',
  FAILED = 'failed',
}

export enum WebsiteCreationActionStatus {
  PENDING = 'pending',
  IN_PROGRESS = 'in progress',
  FAILED = 'failed',
  RETRY = 'retry',
  RETRYING = 'retrying',
  DONE = 'done',
  ROLLING_BACK = 'rolling back',
  ROLLED_BACK = 'rolled back',
  CANCELLED = 'cancelled',
}

export enum WebsiteStatus {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED',
  ERROR = 'ERROR',
}

export interface WebsiteToggleAction {
  id: number;
  action: string;
  status: ToggleActionStatus;
  logs: ToggleLog[];
}

export enum WebsiteToggleState {
  DISABLE = 'disable',
  ENABLE = 'enable',
}

export enum WebsiteToggleStatus {
  PENDING = 'pending',
  DONE = 'done',
  FAILED = 'failed',
}

export interface WebsiteToggle {
  id: number;
  websiteId: number;
  actions: WebsiteToggleAction[];
  state: WebsiteToggleState;
  status: WebsiteToggleStatus;
}

export interface WebsiteSearchResponse {
  Websites: Website[];
  count: number;
}

export interface WebsiteOrchestratorResources {
  creations?: WebsiteCreation[];
  deletions?: WebsiteDeletion[];
  migrations?: WebsiteMigration[];
}

export enum WebsiteOrchestratorResourceType {
  CREATION = 0,
  DELETION = 1,
  MIGRATION = 2,
}

export interface WebsiteOrchestratorResource {
  type: WebsiteOrchestratorResourceType;
  creation?: WebsiteCreation;
  deletion?: WebsiteDeletion;
  migration?: WebsiteMigration;
}
